export default __webpack_public_path__ + "static/media/upload_db.68a45697.svg";